import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { QuestionCircleFill } from "react-bootstrap-icons";
import { sendSupportMessage } from '../../services/supportMessageService';  
import theme from "../../theme/theme";

const SupportButton = ({ userEmail }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState("");
  const [messageText, setMessageText] = useState("");
  const [sending, setSending] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const topics = [
    { id: "myPositions", nameAr: "إدارة مناصبي" },
    { id: "subordinatesList", nameAr: "قائمة المرؤوسين" },
    { id: "assignNewEmployee", nameAr: "تعيين موظف جديد" },
    { id: "searchAndAssign", nameAr: "البحث والإضافة" },
    { id: "other", nameAr: "أخرى" },
  ];

  const handleOpenModal = () => {
    setShowModal(true);
    setSuccessMsg("");
    setErrorMsg("");
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTopic("");
    setMessageText("");
    setSuccessMsg("");
    setErrorMsg("");
  };

  const handleTopicChange = (topicId) => {
    setSelectedTopic(topicId);
    setMessageText("");  
  };

  const handleSubmit = async () => {
    if (!selectedTopic) {
      setErrorMsg("الرجاء اختيار نوع المشكلة");
      return;
    }

    if (!messageText.trim()) {
      setErrorMsg("الرجاء كتابة تفاصيل المشكلة");
      return;
    }

    setSending(true);
    setErrorMsg("");

    try {
      const topicName = topics.find((t) => t.id === selectedTopic)?.nameAr || "";

      const formattedMessage = `${topicName}\n${messageText}`;

      const messageObject = {
        clientEmail: userEmail,
        messageTypeId: 6, // leaderManagement
        messageBody: formattedMessage,
      };

      await sendSupportMessage(messageObject);
      setSuccessMsg("تم إرسال الرسالة بنجاح");
      
      setTimeout(() => {
        handleCloseModal();
      }, 2000);
    } catch (error) {
      setErrorMsg(error.message || "حدث خطأ أثناء إرسال الرسالة");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {/* Floating Support Button */}
      <button
        onClick={handleOpenModal}
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          border: "none",
          backgroundColor:theme.colors.primary,
          color: "white",
          fontSize: "24px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
          cursor: "pointer",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "transform 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        title="الدعم الفني"
      >
        <QuestionCircleFill   />
      </button>

      {/* Support Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>الدعم الفني - قيادي </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {successMsg && (
            <div className="alert alert-success">{successMsg}</div>
          )}
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}

          {/* Step 1: Select Topic */}
          <div className="mb-4">
            <h6 className="mb-3">أين المشكلة؟</h6>
            {topics.map((topic) => (
              <div key={topic.id} className="form-check mb-2 ">
                <input
                  className="form-check-input"
                  type="radio"
                  name="supportTopic"
                  id={topic.id}
                  value={topic.id}
                  checked={selectedTopic === topic.id}
                  onChange={(e) => handleTopicChange(e.target.value)}
                  disabled={sending || successMsg}
                />
                <label className="form-check-label text-dark" htmlFor={topic.id}>
                  {topic.nameAr}
                </label>
              </div>
            ))}
          </div>

          {/* Step 2: Message Details (shown after selecting topic) */}
          {selectedTopic && (
            <div className="mb-3">
              <label htmlFor="messageDetails" className="form-label">
                تفاصيل المشكلة:
              </label>
              <textarea
                id="messageDetails"
                className="form-control"
                rows="5"
                placeholder="اكتب تفاصيل المشكلة هنا..."
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                disabled={sending || successMsg}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            disabled={sending}
          >
            إلغاء
          </Button>
          <button
          className="primary-bg border-none btn"
            onClick={handleSubmit}
            disabled={sending || !selectedTopic || !messageText.trim() || successMsg}
          >
            {sending ? "جاري الإرسال..." : "إرسال"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SupportButton;